import { ArrowRightOnRectangleIcon } from "@heroicons/react/20/solid";
import { Button, ButtonIntent, ButtonState } from "src/components/Button";
import { useTranslation } from "src/translations";

export function EdgeOffsetButton({
  onClick,
  disabled,
  active,
}: {
  onClick: () => void;
  disabled: boolean;
  active: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Button
      title={t("toolbox.edgeOffset")}
      Icon={ArrowRightOnRectangleIcon}
      intent={ButtonIntent.SELECT}
      state={disabled ? ButtonState.DISABLED : active ? ButtonState.ACTIVE : ButtonState.NONE}
      onClick={onClick}
    />
  );
}
